import React, { createContext, useState, useContext, useMemo } from 'react';

const StaplesArtFilesContext = createContext();

export const StaplesArtFilesProvider = ({ children }) => {
  const [value, setValue] = useState(undefined);

  const a = useMemo(
    () => ({
      value,
      setValue,
    }),
    [value]
  );

  return (
    <StaplesArtFilesContext.Provider value={a}>
      {children}
    </StaplesArtFilesContext.Provider>
  );
};

// eslint-disable-next-line import/no-anonymous-default-export
export default () => useContext(StaplesArtFilesContext);
